// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React from 'react';
import './Button.css';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'filled' | 'outlined' | 'link';
  colour?: 'purple' | 'red' | 'green' | 'blue';
  size?: 'lg' | 'md' | 'sm';
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  loading?: boolean;
  fluid?: boolean;
  children: React.ReactNode;
}

export function Button({
  variant = 'filled',
  colour = 'purple',
  size = 'lg',
  iconLeft,
  iconRight,
  loading = false,
  fluid = false,
  children,
  className = '',
  disabled,
  ...rest
}: ButtonProps) {
  const classes = [
    'fin-btn',
    `fin-btn--${variant}`,
    `fin-btn--${colour}`,
    `fin-btn--${size}`,
    'focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2',
    fluid && 'fin-btn--fluid',
    loading && 'fin-btn--loading',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      className={classes}
      disabled={disabled || loading}
      {...rest}
    >
      {loading && <span className="fin-btn__spinner" />}
      {iconLeft && <span className="fin-btn__icon">{iconLeft}</span>}
      {children}
      {iconRight && <span className="fin-btn__icon">{iconRight}</span>}
    </button>
  );
}
